import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

/**
 * AccessibilityAnnouncer component that provides screen reader announcements
 * This component renders aria-live regions that announce feedback and other important messages
 */
const AccessibilityAnnouncer = observer(() => {
  const { accessibilityService } = useContext(MobXProviderContext);

  return (
    <>
      {/* Feedback announcement region */}
      <div
        aria-atomic='true'
        aria-live='assertive'
        className='sr-only'
        id='feedbackAnnouncement'
        // role='status' // TODO: commented out for now since it can interfere with some screen readers (e.g. VoiceOver)
      >
        {accessibilityService.feedbackAnnouncement}
      </div>
    </>
  );
});

export default AccessibilityAnnouncer; 